export default {
    'br.com.azi.hal.usuario.exception.CpfJaExisteException': {
        mensagem: 'O CPF informado já está sendo utilizado por outro usuário.',
    },
    'br.com.azi.hal.usuario.exception.EmailJaExisteException': {
        mensagem: 'O e-mail informado já está sendo utilizado por outro usuário.',
    },
    'br.com.azi.efcaz.clm.domain.usecase.planoAssinaturaOrganizacaoConsumo.validarQuantidadeUsuarios.exception.LimiteUsuariosAtingidoException': {
        ignorarNotificacaoDefault: true,
    },
    'br.com.azi.efcaz.clm.domain.usecase.common.exceptions.LimiteDocumentosAtingidoException': {
        ignorarNotificacaoDefault: true,
    },
    'br.com.azi.efcaz.clm.domain.usecase.organizacao.inserirOrganizacao.exception.OrganizacaoJaExisteException': {
        mensagem: 'Organização já cadastrada.',
        ignorarNotificacaoDefault: false,
    },
    'br.com.azi.efcaz.clm.domain.usecase.cupom.validarCupom.exception.CupomInvalidoPlanoException': {
        mensagem: 'Cupom inválido para esse plano!',
    },
    'br.com.azi.efcaz.clm.domain.usecase.cupom.validarCupom.exception.CupomExpiradoException': {
        mensagem: 'Cupom expirado!',
    },
    'br.com.azi.efcaz.clm.domain.usecase.common.exceptions.CupomInvalidoException': {
        mensagem: 'Cupom inválido!',
    },
    'br.com.azi.efcaz.clm.domain.usecase.common.exceptions.CupomInvalidoFormaPagamentoException': {
        mensagem: 'Cupom inválido para forma de pagamento informada!',
    },
    'br.com.azi.efcaz.clm.domain.usecase.common.exceptions.CupomNaoEncontradoException': {
        mensagem: 'Cupom inválido!',
    },
    'br.com.azi.efcaz.clm.domain.usecase.common.exceptions.CupomInvalidoCompraParceladaException': {
        mensagem: 'Cupom não aplicável para compras parceladas!',
    },
    'br.com.azi.efcaz.clm.domain.usecase.common.exceptions.OrganizacaoNaoExisteException': {
        mensagem: 'Não foi possível localizar a organização.',
    },
    'br.com.azi.efcaz.clm.domain.usecase.common.exceptions.ContratoComNomeDuplicadoException': {
        mensagem: 'Já existe um contrato com o mesmo nome.',
    },
    'br.com.azi.efcaz.clm.domain.usecase.common.exceptions.ContratoNaoExisteException': {
        mensagem: 'Não foi possível localizar o contrato',
    },
    'br.com.azi.efcaz.clm.domain.usecase.common.exceptions.DocumentoJaAssinadoException': {
        mensagem: 'Não é possível excluir documentos com assinaturas.',
    },
    'br.com.azi.efcaz.clm.domain.usecase.common.exceptions.MinutaNaoExisteException': {
        mensagem: 'Não foi possível localizar a minuta.',
    },
    'br.com.azi.efcaz.clm.domain.usecase.contrato.renovarContrato.exception.RenovacaoSemPublicarMinutaException': {
        mensagem: 'Não é possível renovar contrato não formalizado.',
    },
    'br.com.azi.efcaz.clm.domain.usecase.minuta.formalizarMinuta.exception.AssinaturasPendentesException': {
        mensagem: 'Não é possível formalizar o contrato pois existem assinaturas pendentes.',
    },
    'br.com.azi.efcaz.clm.domain.usecase.contrato.moverContrato.exception.UsuarioNaoPossuiPemissaoNaPastaException': {
        mensagem: 'Não é possível mover contratos para pastas em que o usuário não possui acesso.',
    },
    'br.com.azi.efcaz.clm.domain.usecase.pasta.exception.PastaComNomeDuplicadoException': {
        mensagem: 'Já existe uma pasta com o nome informado',
    },
    'br.com.azi.efcaz.clm.domain.usecase.pasta.removerPasta.exceptions.UsuarioNaoPossuiPemissaoParaRemoverPastaException': {
        mensagem: 'Usuário não possui permissão para excluir a pasta',
    },
    'br.com.azi.efcaz.clm.domain.usecase.pasta.removerPasta.exceptions.PastaComContratosNaoPodeSerRemovidaException': {
        mensagem: 'Não é possível excluir uma pasta com contratos',
    },
    'br.com.azi.efcaz.clm.domain.usecase.common.exceptions.SignatarioWhatsAppException': {
        mensagem: 'Signatário esta assinando pelo WhatsApp no momento.\nAguarde concluir a assinatura para adicionar novamente.',
    },
    'br.com.azi.efcaz.clm.domain.usecase.common.exceptions.UsuarioCpfJaCadastradoException': {
        mensagem: 'Usuário possui um CPF inválido. (Documento já em uso)',
    },
    'br.com.azi.efcaz.clm.domain.usecase.common.exceptions.OrganizacaoJaPossuiDocumentoModeloTituloException': {
        mensagem: 'Organização já possui um modelo com esse nome criado!',
    },
    'br.com.azi.efcaz.clm.domain.usecase.common.exceptions.OrganizacaoSemAcessoFuncionalidadeException': {
        mensagem: 'Organização não possui acesso a essa fucionalidade.',
    },
    'br.com.azi.efcaz.clm.domain.usecase.common.exceptions.UsuarioSemAcessoFuncionalidadeAdministradorException': {
        mensagem: 'Apenas administradores da Organização possuem acesso a essa funcionalidade.',
    },
    'br.com.azi.efcaz.clm.domain.usecase.organizacaoPapelSignatario.common.exception.PapelSignatarioOrganizacaoNomeException': {
        mensagem: 'Organização já possui um papel criado com esse nome.',
    },
    'br.com.azi.efcaz.clm.domain.usecase.organizacaoPapelSignatario.common.exception.OrganizacaoPapelSignatarioNaoEncontradoException': {
        mensagem: 'Papel da organização não encontrado.',
    },
    'br.com.azi.efcaz.clm.domain.usecase.organizacaoPapelSignatario.common.exception.EditarOrganizacaoPapelSignatarioModeloException': {
        mensagem: 'Não é possível editar papéis padrão.',
    },
    'br.com.azi.efcaz.clm.domain.usecase.organizacaoPapelSignatario.common.exception.EditarOrganizacaoPapelSignatarioUtilizadoException': {
        mensagem: 'Não foi possível editar o papel. Papel já foi utilizado!',
    },
    'br.com.azi.efcaz.clm.domain.usecase.organizacaoPapelSignatario.editarOrganizacaoPapelSignatario.exception.QuantidadeMinimaPapeisAtivosException':
        {
            mensagem: 'Não foi possível inativar o papel. Pelo menos 1 papel precisa estar ativo!',
        },
    'br.com.azi.efcaz.clm.domain.usecase.organizacaoPapelSignatario.editarOrganizacaoPapelSignatario.exception.OrganizacaoPapelSignatarioUtilizadoCadastroSignatarioException':
        {
            mensagem: 'Não foi possível inativar o papel. Organização possui um contato cadastrado utilizando esse papel!',
        },
    'br.com.azi.efcaz.clm.domain.usecase.common.exceptions.ModeloEditorNomeInvalidoException': {
        mensagem: 'Nome do modelo inválido!.',
    },
}
